import React, { useState, useCallback, useEffect } from "react";
import Layout from "../shared/Layout";
import Edit from "../shared/Edit";
import CardSearchTable from "../shared/CardSearchTable";

import { userTableHeaders } from "../../helpers/estimateTableHeaders";
import { formattedCost } from "../../helpers/formatters";
import { useAuth } from "../../hooks/usehooks.com/use-auth";
import { useOrganization } from "../../hooks/useOrganization";
import apiConfig from "../../config/api.config";

const pageLimit = 30;
const tooltip = `These are the estimates that you have created. ` +
  `To view the estimate details, click the business name.`;

const columns = userTableHeaders().filter((col) => col.name != "value");

const formattedTime = (time) => {
  const dbTime = new Date(time);
  const dateOptions = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  };
  return dbTime.toLocaleTimeString("en-US", dateOptions);
};

const makeV3URL = (endpoint, params) => {
  const searchParams = new URLSearchParams(params);
  return `${apiConfig.legacyApiUrl}/${endpoint}?${searchParams.toString()}`;
};

export default function Legacy() {
  const { user } = useAuth();
  const organization = useOrganization();
  const orgId = organization.current?.id;

  const [estimates, setEstimates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageOffset, setPageOffset] = useState(0);
  const pageCurrent = pageOffset + pageLimit;

  const onSubmit = useCallback(({ search }) => {
    setPageOffset(0);
    setEstimates([]);
    setSearchTerm(search.toLowerCase());
  }, [searchTerm]);

  const onLoadMore = useCallback(() => {
    setPageOffset(pageCurrent);
  }, [pageOffset]);

  const page = {
    records: estimates.length,
    initial: pageLimit,
    current: pageCurrent,
  };

  useEffect(() => {
    if (!user || !orgId) return;

    const estimatesUrl = makeV3URL("estimates", {
      orgId,
      businessName: searchTerm,
      limit: pageLimit,
      offset: pageOffset,
    });
    
    user.getIdToken(true).then((token) => {
      const headers = { Authorization: `Bearer ${token}` };
      return fetch(estimatesUrl, { method: "GET", headers });
    }).then((response) => response.json())
      .then((body) => setEstimates((curr) => [...curr, ...body.data]))
      .catch((err) => console.error(err));
  }, [user, pageOffset, searchTerm, orgId]);

  return (
    <Layout>
      <CardSearchTable
        onSubmit={onSubmit}
        onLoadMore={onLoadMore}
        page={page}
        columns={columns}
        tooltip={tooltip}
        header="V3 Estimates"
        placeholder="Search by Business Name"
        empty="No estimates found."
      >
        {estimates.map((estimate, idx) => {
          return (
            <tr key={`${idx}-${estimate.id}`}>
              <td>{formattedTime(estimate.updatedAt)}</td>
              <td>{estimate.naics}</td>
              <td>{estimate.name}</td>
              <td>{estimate.businessName}</td>
              <td>{estimate.status}</td>
              <td>{estimate.year}</td>
              <td>{estimate.employees}</td>
              <td></td>
              <td>
                <Edit
                  at={`/v3/view/${estimate.id}`}
                  tooltip="View Estimate"
                  readOnly
                />
              </td>
            </tr>
          );
        })}
      </CardSearchTable>
    </Layout>
  );
};
